import {gql} from 'apollo-boost'

export const GET_INGREDIENTS = gql`
    query {
        ingredients {
            id
            name
            category {id name}
        }
    }
`

export const ADD_INGREDIENT = gql`
    mutation($name: String!, $categoryId: ID!) {
        createIngredient(name: $name, categoryId: $categoryId) {
            id
            name
        }
    }
`

export const UPDATE_INGREDIENT = gql`
    mutation($id: ID! $name: String!, $categoryId: ID) {
        updateIngredient(id: $id, name: $name, categoryId: $categoryId ) {
            id
            name
        }
    }
`

export const DELETE_INGREDIENT = gql`
    mutation($id: ID!) {
        deleteIngredient(id: $id) {
            name
        }
    }
`